import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OrderRecipientLastNameEmptyError extends Violation {
	public constructor() {
		super(ViolationSeverity.Error, 'data-model.orders.recipient.validation.last-name.required');
	}
}
